const sectionFaqVitalCss = `
[data-type='section-faq-vital'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-faq-vital'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h1,
[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h2,
[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  line-height: normal;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: 1.4;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card a {
  color: var(--color-text, #000000);
  text-decoration: none;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left {
  width: calc((100% - 32px) / 2);
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .hight-light-group {
  background-color: var(--hl-background, #daecf0);
  max-width: 420px;
  padding: 28px;
  border-radius: 10px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .btn-card-left[data-show='true'] {
  display: flex;
  align-items: center;
  column-gap: 10px;
  font-weight: bold;
  padding-bottom: 6px;
  width: fit-content;
  border-bottom: solid 1px;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .btn-card-left[data-show='true'] svg {
  display: block;
  width: 18px;
  height: auto;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .btn-card-left[data-show='false'] {
  display: none;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right {
  width: calc((100% - 32px) / 2);
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right .wrap-accordion {
  border-bottom: solid 1px #d4dceb;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right .wrap-accordion .accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  cursor: pointer;
}

[data-type='section-faq-vital']
  [data-attribute='card-container']
  .wrap-card
  .card-right
  .wrap-accordion
  .accordion-title
  div:first-child {
  width: calc(100% - 25px);
  font-size: 16px;
}

[data-type='section-faq-vital']
  [data-attribute='card-container']
  .wrap-card
  .card-right
  .wrap-accordion
  .accordion-title
  div:last-child {
  display: flex;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-faq-vital']
  [data-attribute='card-container']
  .wrap-card
  .card-right
  .wrap-accordion
  .accordion-title
  div:last-child
  svg {
  display: block;
  width: 18px;
  height: auto;
}

[data-type='section-faq-vital']
  [data-attribute='card-container']
  .wrap-card
  .card-right
  .wrap-accordion
  .accordion-title
  div:last-child.open {
  transform: rotate(-180deg);
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right .wrap-accordion .accordion-content {
  max-height: 0;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

[data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right .wrap-accordion .accordion-content .accordion-text {
  padding: 10px;
}

@container (max-width: 768px) {
  [data-type='section-faq-vital'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card {
    gap: 16px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h1,
  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h2,
  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card h3 {
    font-size: 20px;
    margin: 0 0 10px 0 !important;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card p {
    font-size: 14px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card a {
    font-size: 14px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left {
    order: 1 !important;
    width: 100%;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left {
    position: relative;
    gap: 10px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .hight-light-group {
    max-width: 100%;
    padding: 16px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-left .block-content-left .btn-card-left[data-show='true'] {
    padding-bottom: 1px;
  }

  [data-type='section-faq-vital'] [data-attribute='card-container'] .wrap-card .card-right {
    width: 100%;
    order: 2 !important;
  }
}
`;
export default sectionFaqVitalCss;
